module.exports = __webpack_public_path__ + "static/gippsland-social-3-effaea5695750047b2ae76169397eaf3.png";